import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const MasterListTableNoResultsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const MasterListTableNoResultsText = styled(typography.TitleOneRegularTypography)``;

export const MasterListTableWrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const MasterListTableGridWrapper = styled.div`
  display: grid;
  grid-template: 1fr / 16fr 16fr 14fr 14fr;
  column-gap: 16px;
  padding: 0 24px;
`;

export const MasterListTableDivider = styled.hr`
  width: calc(100% + 48px);
  grid-column: 1 / 10;
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const MasterListTableHeader = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const MasterListTableItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 68px;
`;

export const MasterListTableItemLink = styled(Link)`
  text-decoration: none;
`;

export const MasterListTableItemText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const MasterListTableItemSubText = styled(typography.BodyTextTwoRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const MasterListTableItemStatus = styled(typography.BodyTextTwoRegularTypography)`
  width: 150px;
  margin: 0;
  padding: 5px 0;
  text-align: center;
  border-radius: 4px;

  ${({ color, backgroundColor }) => `
    color: ${color};
    background-color: ${backgroundColor};
  `};
`;

export const MasterListTableIconBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  &:before {
    content: ${({ icon }) => icon};
    font-family: 'Icomoon';
    color: ${({ theme }) => theme.colors.black};
  }
`;
